
const digest = 'fb2332b0fa8015f1d97175cc86f8a10a49b3ebb762f98a5fc40a80c7c34b585f';
const classes = {"wrapper":"_wrapper_ilr79_1","selected":"_selected_ilr79_11","actions":"_actions_ilr79_15"};
const css = `._wrapper_ilr79_1 {
  font-family: Rubik, "sans-serif";
  background: #f6f6f8;
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: center;
  padding: 12px 34px;
  justify-content: space-between;
}
._wrapper_ilr79_1 ._selected_ilr79_11 {
  font-weight: 500;
  font-size: 14px;
}
._wrapper_ilr79_1 ._actions_ilr79_15 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 30px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  